var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655,
    height: 362,
    viewBox: "0 0 655 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.002 14.9205L443.891 64.4397L426.159 84.8615L446.434 102.763L438.017 108.44L467.676 134.627L441.737 164.501L472.757 211.208L454.986 231.675L470.719 255.362L457.165 264.505L487.706 310.491L52.1786 339.387C34.5443 340.557 19.3004 327.21 18.1304 309.575L2.50709 74.0929C1.33712 56.4585 14.6841 41.2146 32.3185 40.0447L411.002 14.9205Z",
    fill: "url(#paint0_linear_2150_20280)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M602.284 21.0194C619.957 20.961 634.332 35.2405 634.39 52.9136L635.169 288.912C635.227 306.585 620.948 320.959 603.275 321.018L516.06 321.306L493.707 280.071L507.808 271.267L493.592 245.042L512.611 224.489L484.58 172.78L512.341 142.78L484.382 112.964L493.138 107.496L474.025 87.115L493.003 66.6079L468.529 21.4609L602.284 21.0194Z",
    fill: "url(#paint1_linear_2150_20280)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0703 277.229L81.7893 275.457L83.7754 305.391L57.0563 307.164L55.0703 277.229Z",
    fill: "#181C24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7559 274.464L123.475 272.691L125.461 302.625L98.7419 304.398L96.7559 274.464Z",
    fill: "#181C24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.441 271.698L165.16 269.926L167.146 299.86L140.427 301.632L138.441 271.698Z",
    fill: "#181C24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180.129 268.933L206.848 267.16L208.834 297.094L182.115 298.867L180.129 268.933Z",
    fill: "#181C24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.814 266.167L248.533 264.394L250.52 294.328L223.8 296.101L221.814 266.167Z",
    fill: "#181C24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.5 263.401L290.219 261.629L292.205 291.563L265.486 293.336L263.5 263.401Z",
    fill: "#181C24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M305.186 260.635L331.905 258.863L333.891 288.797L307.172 290.569L305.186 260.635Z",
    fill: "#181C24"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M346.873 257.87L373.592 256.097L375.578 286.031L348.859 287.804L346.873 257.87Z",
    fill: "#181C24"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M388.561 255.104L415.28 253.331L417.266 283.265L390.547 285.038L388.561 255.104Z",
    fill: "#181C24"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M535.164 253.762L562.215 253.993L561.959 283.992L534.908 283.761L535.164 253.762Z",
    fill: "#181C24"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M577.213 254.121L604.264 254.352L604.007 284.351L576.957 284.12L577.213 254.121Z",
    fill: "#181C24"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M335.574 213.505C311.825 215.08 294.319 204.227 284.92 182.41L303.605 173.749C309.687 188.188 319.654 194.594 333.904 193.649C348.681 192.669 357.491 184.309 356.686 172.171C355.986 161.616 348.681 155.386 335.839 156.238L314.553 157.65L313.257 138.123L334.895 136.687C345.802 135.963 351.727 129.386 351.132 120.414C350.432 109.859 341.52 103.382 328.502 104.246C315.836 105.086 307.12 112.202 303.21 125.184L283.861 118.516C290.447 97.9358 306.096 86.1192 328.262 84.6485C353.419 82.9795 371.042 95.5925 372.384 115.824C373.26 129.018 366.665 138.82 355.534 144.153C368.703 148.226 377.343 158.608 378.312 173.21C379.771 195.2 362.666 211.707 335.574 213.505Z",
    fill: "#181C24"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M223.122 220.966C191.456 223.067 169.662 198.185 167.129 160.01C164.597 121.835 182.912 94.292 214.578 92.1911C246.068 90.1018 267.862 114.984 270.395 153.159C272.928 191.334 254.612 218.876 223.122 220.966ZM215.909 112.246C197.261 113.483 187.181 131.998 188.944 158.563C190.706 185.127 203.144 202.148 221.791 200.911C240.263 199.685 250.343 181.17 248.581 154.606C246.819 128.042 234.381 111.021 215.909 112.246Z",
    fill: "#181C24"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.858 225.189L114.967 196.69L55.5059 200.635L54.0353 178.468L105.346 102.265L128.919 100.701L133.961 176.7L151.377 175.544L152.615 194.192L135.198 195.347L137.089 223.847L116.858 225.189ZM74.1479 180.668L113.73 178.042L110.299 126.321L74.1479 180.668Z",
    fill: "#181C24"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2150_20280",
    x1: 234.117,
    y1: 26.6561,
    x2: 335.53,
    y2: 380.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2150_20280",
    x1: 551.407,
    y1: 21.1873,
    x2: 445.967,
    y2: 340.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717B8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181C24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.e1c6f6de96353e746db1eddddc8bd7cf.svg";
export { ForwardRef as ReactComponent };